import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function EditGeneralSettingsSchema() {
  const { t } = useTranslation('settings')

  return z.object({
    features: z.string(),
    singleSignOn: z.boolean(),
    toolsMenu: z.boolean(),
    quickAccess: z.boolean(),
    enableAccountEntity: z.boolean(),
    friendlyUrlOrigin: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
        }),
      )
      .min(1, { message: t('general.schemas.friendly_url_origin.required') }),
  })
}

export type EditGeneralSettingsSchemaForm = z.infer<
  ReturnType<typeof EditGeneralSettingsSchema>
>
